import { render, staticRenderFns } from "./DossierInfo.vue?vue&type=template&id=38f35d4f&"
import script from "./DossierInfo.vue?vue&type=script&lang=ts&"
export * from "./DossierInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f35d4f')) {
      api.createRecord('38f35d4f', component.options)
    } else {
      api.reload('38f35d4f', component.options)
    }
    module.hot.accept("./DossierInfo.vue?vue&type=template&id=38f35d4f&", function () {
      api.rerender('38f35d4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DossierInfo.vue"
export default component.exports